export type Drama = {
  id: string;
  title: string;
  category: string;
  tags: string[];
  episodes: number;
  progress: number;
  duration: string;
  year: number;
  heat: number;
  status: string;
  summary: string;
};

export const dramaCategories: string[] = [
  "全部",
  "温馨日常",
  "冲突反转",
  "家庭伦理",
  "都市情感",
  "逆袭爽感",
];

export const dramas: Drama[] = [
  {
    id: "d-01",
    title: "岳母的第一课",
    category: "温馨日常",
    tags: ["初见家长", "代际沟通"],
    episodes: 60,
    progress: 60,
    duration: "单集约2分钟",
    year: 2025,
    heat: 9860,
    status: "已完结",
    summary:
      "第一次上门，男人把礼物拿错、把称呼叫错，一连串尴尬之后，一顿家常便饭化解了所有紧张。",
  },
  {
    id: "d-02",
    title: "她妈妈不同意",
    category: "冲突反转",
    tags: ["家庭阻力", "长线证明"],
    episodes: 72,
    progress: 65,
    duration: "单集约2分钟",
    year: 2025,
    heat: 9640,
    status: "连载中",
    summary:
      "女方母亲坚决反对这段感情，男主用三年时间证明自己，却在订婚前夜发现反对背后另有隐情。",
  },
  {
    id: "d-03",
    title: "准岳母的秘密",
    category: "家庭伦理",
    tags: ["隐藏往事", "情感悬念"],
    episodes: 48,
    progress: 48,
    duration: "单集约3分钟",
    year: 2024,
    heat: 8120,
    status: "已完结",
    summary:
      "准岳母忽然改口同意婚事，男主在帮未来岳母整理旧物时，翻出一段尘封多年的往事。",
  },
  {
    id: "d-04",
    title: "第一次见家长",
    category: "温馨日常",
    tags: ["见面礼", "餐桌细节"],
    episodes: 36,
    progress: 36,
    duration: "单集约2分钟",
    year: 2025,
    heat: 7350,
    status: "已完结",
    summary:
      "从挑礼物到坐上饭桌，每一集讲一个见家长的细节，男主一路磕磕绊绊慢慢被接纳。",
  },
  {
    id: "d-05",
    title: "岳母的考验",
    category: "冲突反转",
    tags: ["试探", "真心"],
    episodes: 80,
    progress: 78,
    duration: "单集约2分钟",
    year: 2025,
    heat: 10320,
    status: "连载中",
    summary:
      "岳母安排三次意外考验准女婿，男主每次都用笨办法过关，直到第三次考验暴露了岳母的真实目的。",
  },
  {
    id: "d-06",
    title: "女朋友的妈妈是我上司",
    category: "都市情感",
    tags: ["职场", "双重身份"],
    episodes: 64,
    progress: 64,
    duration: "单集约3分钟",
    year: 2024,
    heat: 8890,
    status: "已完结",
    summary:
      "男主入职第一天，发现顶头上司竟是女友的妈妈，办公室与家宴两头周旋，笑料与压力齐飞。",
  },
  {
    id: "d-07",
    title: "岳母驾到",
    category: "冲突反转",
    tags: ["同住磨合", "边界感"],
    episodes: 56,
    progress: 40,
    duration: "单集约2分钟",
    year: 2025,
    heat: 7640,
    status: "连载中",
    summary:
      "岳母临时搬来同住，生活习惯处处相左，从抢厨房到抢遥控器，一屋三人重新学习共处。",
  },
  {
    id: "d-08",
    title: "妈妈的择婿标准",
    category: "家庭伦理",
    tags: ["清单", "现实压力"],
    episodes: 44,
    progress: 44,
    duration: "单集约3分钟",
    year: 2024,
    heat: 6980,
    status: "已完结",
    summary:
      "女友妈妈列出一张十三条择婿清单，男主逐条对照，越比越心凉，最后一条却让他愣住。",
  },
  {
    id: "d-09",
    title: "准女婿的逆袭",
    category: "逆袭爽感",
    tags: ["低谷翻身", "证明自己"],
    episodes: 90,
    progress: 82,
    duration: "单集约2分钟",
    year: 2025,
    heat: 11240,
    status: "连载中",
    summary:
      "被岳母当众看轻的男主，从送外卖到重新创业，一路让当初的质疑一个个收回。",
  },
  {
    id: "d-10",
    title: "岳母的眼泪",
    category: "温馨日常",
    tags: ["母女情", "释怀"],
    episodes: 40,
    progress: 40,
    duration: "单集约3分钟",
    year: 2024,
    heat: 7210,
    status: "已完结",
    summary:
      "一向强势的岳母在女儿婚礼上落泪，男主第一次读懂这位长辈这些年的不容易。",
  },
  {
    id: "d-11",
    title: "陪女友回家过年",
    category: "温馨日常",
    tags: ["春节", "走亲戚"],
    episodes: 52,
    progress: 52,
    duration: "单集约2分钟",
    year: 2025,
    heat: 8460,
    status: "已完结",
    summary:
      "七天春节假期，男主跟着女友走遍亲戚，从被盘问到被维护，这个年过得格外有滋味。",
  },
  {
    id: "d-12",
    title: "岳母和我的一百天",
    category: "都市情感",
    tags: ["同住", "慢慢熟络"],
    episodes: 68,
    progress: 52,
    duration: "单集约3分钟",
    year: 2025,
    heat: 7930,
    status: "连载中",
    summary:
      "女友出差一百天，男主和岳母同住一个屋檐下，从无话可说到无话不谈。",
  },
];